export default __webpack_public_path__ + "static/media/docker.a2e80b4e.png";